import { PropsWithChildren } from 'react'

export function Wrapper({ children }: PropsWithChildren<unknown>) {
  return (
    <div className="mx-auto my-8 w-full space-y-8 px-4 sm:px-8 md:max-w-3xl lg:max-w-5xl xl:max-w-7xl">
      {children}
    </div>
  )
}
